import { Component } from '@angular/core';

@Component({
  selector: 'app-portal-profile',
  imports: [],
  templateUrl: './portal-profile.component.html',
  styleUrl: './portal-profile.component.css'
})
export class PortalProfileComponent {

}
